const _excluded = ["className", "illustration", "message", "actions", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import styles from "./PageEmptyState.module.scss";
import { Typography } from "../Typography";
export function PageEmptyState(_ref) {
  let {
    className,
    illustration,
    message,
    actions,
    title
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.root, className)
  }, rest), illustration, /*#__PURE__*/React.createElement("div", {
    className: styles.textualContent
  }, title ? typeof title === 'string' ? /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "normal"
  }, title) : title : null, /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, typeof message === 'string' ? /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1"
  }, message) : {
    message
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.actionsContainer
  }, actions));
}